import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { IWorkshopEvaluationQuestionOption } from 'models/workshopEvaluationQuestionOption';
import { IVendorAssessmentQuestionOption } from 'models/vendorAssessmentQuestionOption';


interface Props {
  open: boolean;
  loading: boolean;
  vendorAssessmentQuestionOption: IVendorAssessmentQuestionOption;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditWorkshopEvaluationQuestionOption: React.FC<Props> = ({ open, loading, vendorAssessmentQuestionOption, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let basicFields: IFormField[] = [
    {
      name: 'description',
      label: t('T_description'),
      placeholder: t('T_enter_description'),
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestionOption.description,
      internalLabel: true,
      required: true
    },
    {
      name: 'descriptionAr',
      label: `${t('T_enter_description')} ${t('T_in_arabic')}`,
      placeholder: `${t('T_enter_description')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestionOption.descriptionAr,
      internalLabel: true,
      required: true
    },
    {
      name: 'score',
      label: t('T_score'),
      type: InputTypes.NUMBER,
      defaultValue: vendorAssessmentQuestionOption.score,
      internalLabel: true,
      required: true
    },
    {
      name: 'optionOrder',
      label: t('T_order'),
      type: InputTypes.NUMBER,
      defaultValue: vendorAssessmentQuestionOption.optionOrder,
      internalLabel: true,
      required: true
    }
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_vendor_assessment_question_option')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_edit')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditWorkshopEvaluationQuestionOption;
